import { AutocompleteProps } from '@freighthub/silhouette-core'
import { observer } from 'mobx-react'
import { Component } from 'react'

import { NetworkAutocomplete } from '../NetworkAutocomplete/NetworkAutocomplete'
import { AutocompleteResult } from '../NetworkAutocomplete/NetworkAutocompleteOption'
import { IContactJSON, IContactResJSON } from './ContactsModel'

export interface IContactsAutocompleteProps {
  organizationId: string
  contactIds: string[]
  searchContacts: (searchText: string, organizationId: string) => Promise<IContactResJSON>
  handleContactSelection: (selection: AutocompleteResult) => void
  filter: AutocompleteProps['filterOptions']
  fetchDefaultOptionOnOpen: boolean
}

export class LeanContactsAutocomplete extends Component<IContactsAutocompleteProps> {
  constructor(props) {
    super(props)
    this.formatContactToCompletion = this.formatContactToCompletion.bind(this)
    this.getContactCompletions = this.getContactCompletions.bind(this)
  }

  formatContactToCompletion(contact: IContactJSON): AutocompleteResult {
    if (!contact) {
      // @ts-expect-error TS(2322) FIXME: Type 'undefined' is not assignable to type 'Autoco... Remove this comment to see the full error message
      return
    }
    return { label: `${contact.name} ${contact.email}`, value: contact._id, data: { entity: contact } }
  }

  getContactCompletions(searchText: string): Promise<AutocompleteResult[]> {
    const { organizationId, contactIds } = this.props
    if (!organizationId) {
      return Promise.resolve([])
    }
    return this.props.searchContacts(searchText, organizationId).then((results) => {
      return results.data
        .filter((contact) => !contactIds.some((id) => id === contact._id))
        .map(this.formatContactToCompletion)
    })
  }

  render() {
    const { handleContactSelection, filter, fetchDefaultOptionOnOpen } = this.props
    const additionalProps = fetchDefaultOptionOnOpen ? { key: Math.random() } : {}
    return (
      <NetworkAutocomplete
        {...additionalProps}
        getCompletions={this.getContactCompletions}
        handleSelection={handleContactSelection}
        clearOnSelect
        filterOptions={filter}
      />
    )
  }
}

export const ContactsAutocomplete = observer(LeanContactsAutocomplete)
